import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "file-preview-body"
};
import { ref, watch, computed } from 'vue';
import Preview from '@/components/FilePreview/Preview.vue';
export default {
  __name: 'FilePreview',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ''
    }
  },
  emits: ['update:visible'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    var localVisible = ref(props.visible);

    // 监听外部props变化
    watch(function () {
      return props.visible;
    }, function (val) {
      localVisible.value = val;
    });
    var newPath = computed(function () {
      return props.path;
    });
    var handleClose = function handleClose() {
      localVisible.value = false;
      emit('update:visible', false);
    };
    return function (_ctx, _cache) {
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: localVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return localVisible.value = $event;
        }),
        width: "100%",
        placement: "center",
        header: "文件预览",
        attach: "body",
        "on-close": handleClose,
        mode: 'full-screen',
        class: "file-preview-dialog"
      }, {
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(Preview, {
            path: newPath.value
          }, null, 8, ["path"])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
};